module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/fast-internet-1239eeea4e53995159d02019a100800a.jpeg";